import { useEffect, useState } from 'react'

import { t } from '../i18n'

/** Степпер: − значение + (участники, места). */
export function Stepper({
  value,
  min,
  max,
  step = 1,
  label,
  onChange,
}: {
  value: number
  min: number
  max: number
  step?: number
  label: string
  onChange: (v: number) => void
}) {
  return (
    <div className="stepper" role="group" aria-label={label}>
      <button className="ghost" disabled={value - step < min} onClick={() => onChange(value - step)} aria-label="−">
        −
      </button>
      <span className="stepper-value">{value}</span>
      <button className="ghost" disabled={value + step > max} onClick={() => onChange(value + step)} aria-label="+">
        +
      </button>
    </div>
  )
}

/** Готовые значения чипами + своё число (очки за матч, раунды, корты).
 *  allowAuto: первый чип «Авто» — значение 0. */
export function PresetNumber({
  value,
  presets,
  min,
  max,
  unit,
  allowAuto = false,
  allowUnlimited = false,
  label,
  onChange,
}: {
  value: number
  presets: number[]
  min: number
  max: number
  unit?: string
  allowAuto?: boolean
  /** Чип «Без лимита» — значение −1 */
  allowUnlimited?: boolean
  label: string
  onChange: (v: number) => void
}) {
  const custom = value > 0 && !presets.includes(value)
  const [raw, setRaw] = useState(custom ? String(value) : '')

  useEffect(() => {
    if (!presets.includes(value) && value > 0) setRaw(String(value))
    else setRaw('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  function commit(text: string) {
    const n = Number(text)
    if (text === '' || !Number.isFinite(n)) return
    onChange(Math.max(min, Math.min(max, Math.round(n))))
  }

  return (
    <div className="chips" role="group" aria-label={label}>
      {allowAuto && (
        <button className="chip" aria-pressed={value === 0} onClick={() => onChange(0)}>
          {t().autoValue}
        </button>
      )}
      {allowUnlimited && (
        <button className="chip" aria-pressed={value === -1} onClick={() => onChange(-1)}>
          ∞ {t().roundsUnlimited}
        </button>
      )}
      {presets.map((v) => (
        <button key={v} className="chip" aria-pressed={value === v} onClick={() => onChange(v)}>
          {v}
          {unit ? ` ${unit}` : ''}
        </button>
      ))}
      <input
        className={`chip-input${custom ? ' on' : ''}`}
        inputMode="numeric"
        placeholder={t().customValue}
        aria-label={`${label}: ${t().customValue}`}
        value={raw}
        onChange={(e) => setRaw(e.target.value.replace(/\D/g, '').slice(0, 2))}
        onBlur={() => commit(raw)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') (e.target as HTMLInputElement).blur()
        }}
      />
    </div>
  )
}
